module.exports = __webpack_public_path__ + "img/zuo@3x.228ca639.png";